export const FirebaseConfig = {
	"apiKey": "AIzaSyDyGVydK5QiopT_XiEVnKQu-uXf6WX1iGk",
	"authDomain": "bis-39-mobilidade-urbana.firebaseapp.com",
	"databaseURL": "https://bis-39-mobilidade-urbana-default-rtdb.firebaseio.com",
	"projectId": "bis-39-mobilidade-urbana",
	"storageBucket": "bis-39-mobilidade-urbana.firebasestorage.app",
	"messagingSenderId": "510164255885",
	"appId": "1:510164255885:web:56b663bc028ffca4d40ec4",
	"measurementId": "G-H5NQ6V5XPQ"
}; 